var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDatafirst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "32px",
    viewBox: "0 0 37 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-datafirst") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flueid-Desktop-Home-2023-v2",
    transform: "translate(-235.000000, -7512.000000)",
    fill: "#F0F0F0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 6727.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy-8",
    transform: "translate(230.638889, 785.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.013889, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.95470486,29 L19.472691,29 C20.1621007,29.9 20.983125,30.75625 21.9482986,31.525 C21.3842361,31.83125 20.7386979,32 20.0555556,32 L4.01111111,32 C1.79559896,32 0,30.20625 0,28 L0,4 C0,1.790625 1.79559896,0 4.01111111,0 L14.3835938,0 C15.4490451,0 16.4643576,0.4214375 17.216441,1.171875 L22.8946701,6.83125 C23.6467535,7.58125 24.0666667,8.59375 24.0666667,9.65625 L24.0666667,12.9375 L21.0583333,14.1375 L21.0583333,10 L16.0444444,10 C14.9351215,10 14.0388889,9.10625 14.0388889,8 L14.0388889,3 L4.01111111,3 C3.45707639,3 3.00833333,3.4475 3.00833333,4 L3.00833333,28 C3.00833333,28.55 3.45707639,29 4.01111111,29 L3.95470486,29 Z M26.5172049,14.10625 C26.8744444,13.9625 27.2755556,13.9625 27.6327951,14.10625 L35.1536285,17.10625 C35.7239583,17.3375 36.1,17.8875 36.1,18.5 C36.1,22.45625 34.4767535,29.05 27.6515972,31.8875 C27.2818229,32.0375 26.8681771,32.0375 26.4984028,31.8875 C19.6732465,29.05 18.05,22.45625 18.05,18.5 C18.05,17.8875 18.3696354,17.3375 18.9963715,17.10625 L26.5172049,14.10625 Z M27.075,17.1125 L27.075,28.85625 C31.3493403,26.79375 32.8033681,22.66875 33.0540625,19.44375 L27.075,17.1125 Z",
    id: "icon-datafirst"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDatafirst);
export default __webpack_public_path__ + "static/media/icon-datafirst.5ead014149997bde798cf13d490826b8.svg";
export { ForwardRef as ReactComponent };